import 'katex/dist/katex.min.css'
import './styles/globals.css'

// Shared prose styles from @blogging/ui package
import '@blogging/ui/styles/prose-blogging.css'
import '@blogging/ui/styles/prosemirror.css'

import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
